export default __webpack_public_path__ + "img/68f52a3f4d0fc913973844fae8a589a9.svg";